import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePayment } from "../hooks";
import { PaymentMethod } from "../models/payment";
import { CheckCircle } from "@mui/icons-material";

const PaymentMethods = ({ payments = [] }: { payments: PaymentMethod[] }) => {
  const { selectedMethod, setSelectedMethod } = usePayment();
  const { t } = useTranslation();

  return (
    <Box mb={4}>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        {`${t("payment.select_method")}*`}
      </Typography>

      {/* Wraps instead of dividing the row into fixed quarters. Each tile is a
          fixed 80-100px, so a 25% share is narrower than its own contents in
          any column under ~400px -- which is the searched journey's 40% column,
          where the tiles overlapped by 33px and their labels by 38px. */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          marginTop: 2,
        }}
      >
        {payments.filter(method => method?.is_active).map((method: PaymentMethod) => {
          const isSelected = selectedMethod?.id === method.id;

          return (
            <Box
              key={method?.id}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                width: { xs: "80px", md: "100px" },
              }}
            >
              <Box
                onClick={() => setSelectedMethod(method)}
                sx={{
                  width: { xs: "80px", md: "100px" },
                  height: { xs: "60px", md: "70px" },
                  objectFit: "contain",
                  borderRadius: 1,
                  overflow: "hidden",
                  position: "relative",
                  border: isSelected ? "2px solid #06961C" : "2px solid #FFF",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backdropFilter: "blur(3px)",
                  backgroundColor: "rgba(0,0,10,0.4)",
                }}
              >
                <img
                  src={method.logo.url}
                  width="100%"
                  height="100%"
                  alt={t("payment.provider_logo_alt")}
                />
              </Box>
              <Box sx={{ pt: isSelected ? 1 : 2.5 }}>
                {isSelected ? (
                  <Box sx={{ pt: 1 }}>
                    <CheckCircle color="success" />
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      fontSize: isSelected ? 16 : 13,
                    }}
                    textAlign="center"
                  >
                    {method.name}
                  </Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PaymentMethods;
